import axios from 'axios'
import store from '@/store/store'
// import store from '@/store'
const API = "https://veki.pl/wp-json/";
// create an axios instance
const service = axios.create({
  baseURL: API,
  timeout: 50000, // request timeout
  headers: {
  }
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    
    return config
  },
  error => {
    if (process.env.NODE_ENV==='development') {
      //console.log(error)
    }
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error);
  }
)

export default service
